import {combineReducers} from 'redux'
import {routerReducer as router} from 'react-router-redux'
import today from 'redux/modules/today'
import currentUser from 'redux/modules/currentUser'
import users from 'redux/modules/users'
import merchants from 'redux/modules/merchants'
import sites from 'redux/modules/sites'
import dashboard from 'redux/modules/dashboard'
import analytics from 'redux/modules/analytics'
import reports from 'redux/modules/reports'
import orders from 'redux/modules/orders'
import aggr from 'redux/modules/aggr'
import ui from 'redux/modules/ui'
import settings from 'redux/modules/settings'
import integrations from 'redux/modules/integrations'
import insights from 'redux/modules/insights'
import account from 'redux/modules/account'
import billing from 'redux/modules/billing'
import wizard from 'redux/modules/wizard'
import unsubscribe from 'redux/modules/unsubscribe'
import notifications from 'redux/modules/notifications'
import appSettings from 'redux/modules/app-settings'
import onboard from 'redux/modules/onboard'
import error from 'redux/modules/error'
import {reducer as form} from 'redux-form'

export default combineReducers({
  today,
  currentUser,
  users,
  merchants,
  sites,
  dashboard,
  analytics,
  reports,
  orders,
  aggr,
  router,
  ui,
  settings,
  integrations,
  account,
  insights,
  billing,
  wizard,
  error,
  unsubscribe,
  notifications,
  form,
  appSettings,
  onboard
})



// WEBPACK FOOTER //
// ./client/redux/rootReducer.js